import { graphql } from '@gql';

export const GET_PROJECT_ASSETS = graphql(`
    query GetProjectAssets($pid: ID!) {
        assets(where: { hasProjectZoneWith: { projectID: $pid } }) {
            totalCount
            edges {
                node {
                    ...AssetBaseFragment
                }
            }
        }
    }
`);

export const GET_PROJECT_ASSETS_COUNT = graphql(`
    query GetProjectAssetsCount($pid: ID!) {
        assets(where: { hasProjectZoneWith: { projectID: $pid } }) {
            totalCount
        }
    }
`);

export const GET_ASSETS_IN_PROJECT_ZONE = graphql(`
    query GetAssetsInProjectZone($pzid: ID!) {
        assets(where: { projectZoneID: $pzid }) {
            edges {
                node {
                    ...AssetBaseFragment
                }
            }
        }
    }
`);

export const GET_ASSET_ITEM = graphql(`
    query GetAssetItem($id: ID!) {
        assetItems(where: { id: $id }) {
            edges {
                node {
                    ...FullAssetItemFragment
                }
            }
        }
    }
`);

export const GET_SINGLE_ASSET_NAME_ONLY = graphql(`
    query getAssetName($assetId: ID!) {
        assets(where: { id: $assetId }) {
            edges {
                node {
                    id
                    name
                    projectZone {
                        id
                        name
                    }
                }
            }
        }
    }
`);

export const GET_PROJECT_ASSETS_SEARCH = graphql(`
    query GetProjectAssetsSearch(
        $pid: ID!
        $first: Int!
        $after: Cursor
        $search: String
    ) {
        assetsInProject(
            projectID: $pid
            first: $first
            after: $after
            orderBy: { field: NAME, direction: ASC }
            where: { nameContainsFold: $search }
        ) {
            totalCount
            pageInfo {
                hasNextPage
                endCursor
            }
            edges {
                node {
                    id
                    name
                    projectZone {
                        id
                        name
                    }
                }
            }
        }
    }
`);

export const GET_ASSET_TYPES = graphql(`
    query AssetTypes {
        assetTypes {
            edges {
                node {
                    id
                    name
                }
            }
        }
    }
`);

export const GET_ITEM_ATTRIBUTES = graphql(`
    query ItemAttributeDefinitionsForProject($pid: ID!) {
        assetItemAttributeDefinitionsForProject(projectID: $pid) {
            edges {
                node {
                    ...AssetItemAttributeDefinitionFragment
                }
            }
        }
    }
`);

export const GET_ASSET_ATTRIBUTES = graphql(`
    query AssetAttributeDefinitionsForProject($pid: ID!) {
        assetAttributeDefinitionsForProject(projectID: $pid) {
            edges {
                node {
                    ...AttributeDefinitionFragment
                    assetType {
                        id
                        name
                    }
                }
            }
        }
    }
`);

export const GET_SBOM_ASSETS = graphql(`
    query GetSBOMAssets(
        $id: ID!
        $format: SBOMExportFormat!
        $includeComponentInfo: Boolean!
        $includeVulnerabilities: Boolean!
    ) {
        exportProjectSBOM(
            id: $id
            format: $format
            includeComponentInfo: $includeComponentInfo
            includeVulnerabilities: $includeVulnerabilities
        ) {
            fileName
            content
            type
        }
    }
`);
